import { AxiosError } from 'axios';
import { RequestFileResponse } from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import { useCustomMutation } from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import { POST_GENERATE_PRESIGNED_URL_FOR_UPLOADING_PROFILE_AMENDMENT_REQUEST_FILES_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface GeneratePresignedUrlForUploadingAmendmentRequestFiles {
  uuid: string | null;
  filenames: string[];
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: RequestFileResponse[]) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostGeneratePresignedUrlForUploadingProfileAmendmentRequestFiles = ({
  onSuccess,
  onError,
}: Input = {}) => {
  const postGeneratePresignedUrlForUploadingProfileAmendmentRequestFiles = async (
    reqBody: GeneratePresignedUrlForUploadingAmendmentRequestFiles
  ) => {
    const res = await axiosClient.post<RequestFileResponse[]>(
      POST_GENERATE_PRESIGNED_URL_FOR_UPLOADING_PROFILE_AMENDMENT_REQUEST_FILES_URL,
      reqBody
    );
    return res.data;
  };

  return useCustomMutation(postGeneratePresignedUrlForUploadingProfileAmendmentRequestFiles, {
    onSuccess,
    onError,
  });
};
